import { getRequest } from '..';

export function getAll() {
  return getRequest('/appmodule/organisation/current/');
}

export function getAllActive() {
  return getRequest('/appmodule/organisation/current/active');
}
